export default "<span (click)=\"logout()\" >{{ 'Logout' | translate }}</span>"